export default __webpack_public_path__ + "static/media/audio.ff4b09db.svg";